import React, { useState, useEffect } from 'react';
import '../../css/leadCard.css';
import { fetchWithDefaults } from '../../config/fetchDefault';
import LeadData from '../conversations/leadData';
import QueueScripts from '../callQueue/elements/scripts';
import QueueConvo from '../callQueue/elements/conversation';
import QueueNotes from '../callQueue/elements/notes';
import Recommendation from '../callQueue/elements/sections/recommendation';
import RightQueueHeader from '../callQueue/elements/rightQueueHeader';
import Email from '../email/email';
import { getCurrentAge, getTimestampForTimezone, UnixTimestampToDate } from '../../utilities/timeFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { setCall } from '../../features/callSlice';
import LeadCallRecordings from './leadRecording';
import Scripting from '../scripting/scripting';
import Qualifier from '../qualifier/qualifier';
import { updateSpecificLead } from '../../features/queueSlice';
import { healthRatingPrefix, runVM } from '../../utilities/virtualMentor';
import { addTag, leadCardTabOptions, removeTag, updateStatusName } from '../../utilities/leadFunctions';
import DispositionBlock from '../callQueue/elements/sections/dispositions';
import Dial from '../callQueue/elements/handleDial';
import { SuccessAlert } from '../successAlert';
import image from '../../assets/icons/loading-loader.gif';
import { determineHealthRating, tobaccoRatings, nonTobaccoRatings } from '../../utilities/virtualMentor';
import Script from '../scripting/script';
import { canMessageCurrentLeadTCPA } from '../../utilities/tcpafunctions';
import { useDebouncedCallback } from "use-debounce"
import { isDeepEqual } from '../../utilities/genericUtils';
import AddEvent from '../callQueue/elements/sections/addEvent';
import { setProducts, setReccomendations } from '../../features/productRecommendationSlice';
import EditEvent from '../callQueue/elements/sections/editEvent';
import { fetchLeadDataThunk, updateSingleField } from "../../features/leadDataInfoSlice";
import { setRingState } from '../../features/callSlice';
import { setStartSession } from '../../features/callSlice';
import * as amplitude from "@amplitude/analytics-browser";
import { fetchActivityThunk } from '../../features/scheduledCallSlice';


function LeadCard({ selectedNumber, maxList, theCall, fetchQueue, jumpIntoQueue, dialPackage, setLoading, data, textingNumbers, handleSoftPhone, openViaDial, device, setCallerId, from, newAppt, setNewAppt, permission }) {
    const isFeature970Enabled = process.env.REACT_APP_FUNNEL_FEATURE_970 === 'true'
    const isFeature875Enabled = process.env.REACT_APP_FUNNEL_FEATURE_875 === 'true'

    const dispatch=useDispatch();
    const [apptSet, setApptSet] = useState(false);
    const [selectedTab, setSelectedTab] = useState('term');
    const queue = useSelector((state) => state.queue.queue);
    const loadingGif = useSelector((state) => state.loading.loading);
    const [successTrigger, setSuccessTrigger] = useState(false);
    const [flowData, setFlowData] = useState(false);
    const [isEmailOpen, setIsEmailOpen] = useState(false);
    const [scriptType, setScriptType] = useState('dynamic');
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [term, setTerm] = useState('15');
    const [faceAmount, setFaceAmount] = useState('100000');
    const [possibleConditions, setPossibleConditions] = useState([]);
    const agentInfo = useSelector((state) => state.agent.userData);
    const [qualifier, setQualifier] = useState(false);
    const [currentScript, setCurrentScript] = useState(null);
    const [results, setResults] = useState(false);
    const [alreadyTagged, setAlreadyTagged] = useState(false);
    const [profile, setProfile] = useState({healthRating: null});
    const [scripting, setScripting] = useState(false);
    const [selected, setSelected] = useState(leadCardTabOptions.TEXT);
    const [conversations, setConversations] = useState([]);
    const [healthRating, setHealthRating] = useState('SPNT')
    const [prevProfile, setPrevProfile] = useState({productOption: null, healthRating: null, })
    const [update, setUpdate] = useState(false);

    //  ===== leads popup full data =====
    const leadsAlldata = useSelector((state) => state.leadAllDataInfo?.leadsAllInfoData);

    const handleSelectedTab = (type) => {
        let typeId;
        let resetTerm = false
        const parsedFaceAmount = parseInt(faceAmount)

        if(type==='term'){
            typeId='7';
        }
        else {
            typeId = '6'
        }

        if((typeId==='7' && parsedFaceAmount !== 100000) || (typeId==='6' && parsedFaceAmount !== 25000 && parsedFaceAmount >= 100000)){
            resetTerm = true
        }

        if(resetTerm){
            // pulling in faceAmount update logic
            // from recommendation, to ensure that
            // the correct faceAmount is set when
            // the tab changes between Term and Whole Life
            // this change triggers an immediate call to runVM
            // without this check the immediate request will have
            // the incorrect faceAmount when that call is made
            if(typeId==='7'){
                if(parsedFaceAmount !== 100000){
                    setFaceAmount('100000')
                    setProfile(prevState => ({
                        ...prevState,
                        faceAmount: '100000',
                        productOption: typeId
                    }));
                }
            }
            else if(typeId==='6'){
                if(parsedFaceAmount !== 25000 && parsedFaceAmount >= 100000){
                    setFaceAmount('25000')
                    setProfile(prevState => ({
                        ...prevState,
                        faceAmount: '25000',
                        productOption: typeId
                    }));
                }
            }
        } else {
            handleProfileUpdate('productOption',typeId)
        }
        setSelectedTab(type)
    }
    const selectTab = (option) => {
        if (option === leadCardTabOptions.QUOTE) {
            setScripting(true)
        }
        setSelected(option)
    }
    const [newObjection, setNewObjection] = useState(false);
    const handleNewObjection = (objection) => {
        setNewObjection(objection);
    }
    const agentId = agentInfo.agentId;
    const [newEvent, setNewEvent] = useState(false);
    const [date, setDate] = useState(false);
    const [time, setTime] = useState(false);
    const [event, setEvent] = useState(false);

    const stopFlow = async (id) => {
        try {
            const response = await fetchWithDefaults(`/stopFlow?flow=${id}`);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const jsonData = await response.json();
            setFlowData(false);

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const handleQualifier = () => {
        setQualifier(!qualifier);
    }

    function transformTags(input) {
        // Split the input string by comma to get individual pairs
        const pairs = input?.split(',');

        // Transform each pair into the desired format
        const transformedArray = pairs.map(pair => {
            // Split each pair by '*' to get id and name
            const [id, name] = pair.split('*');

            return { name, id };
        });

        return transformedArray;
    }
    const parseWeight = (input) => {
        // Use a regular expression to extract the numeric part
        const parsedWeight = parseInt(input.match(/\d+/), 10);
        return parsedWeight;
    };

    useEffect(() => {
        const tobaccoUse = (leadsAlldata && leadsAlldata.tobacco !== undefined && leadsAlldata.tobacco !== null) ? leadsAlldata.tobacco : 'no'
        const healthPrefix = healthRating ? healthRatingPrefix[healthRating] : 'S'

        const updatedProfile = {
            ...profile,
            borrower_sex:leadsAlldata? leadsAlldata.borrower_sex : 'male',
            borrower_age:leadsAlldata ?(leadsAlldata.borrower_dob? getCurrentAge(leadsAlldata.borrower_dob) : leadsAlldata.borrower_age):null,
            state:leadsAlldata ? leadsAlldata.state : null,
            feet: leadsAlldata ? parseInt(leadsAlldata.feet) : null,
            inches: leadsAlldata ? parseInt(leadsAlldata.inches) : null,
            weight: leadsAlldata && leadsAlldata.weight ? parseWeight(leadsAlldata.weight) : null,
            faceAmount: faceAmount,
            tobacco: tobaccoUse,
            term: term,
            productOption: profile.productOption ?? 7,
            qualifiers: profile.qualifiers ?? [],
            healthRating: determineHealthRating(tobaccoUse, healthPrefix),
            borrower_sex: leadsAlldata ? leadsAlldata.borrower_sex : null,
            borrower_dob: leadsAlldata ? leadsAlldata.borrower_dob : null,
        }

        if(!isDeepEqual(updatedProfile, profile)){
            setProfile(prevState => ({
                ...prevState,
                ...updatedProfile
            }))

            dispatch(setProducts([]))
            dispatch(setReccomendations([]))
        }

    }, [leadsAlldata.lead_id,leadsAlldata.borrower_sex,leadsAlldata.borrower_age,leadsAlldata.state,leadsAlldata.feet,leadsAlldata.inches,leadsAlldata.weight,leadsAlldata.borrower_dob, term, healthRating, leadsAlldata.tobacco]);

    // Reset selected tab when the lead changes.
    // This would happen, for example, when the lead card is opened in a dial session
    useEffect(()=>{
        setSelected(leadCardTabOptions.TEXT)
    }, [leadsAlldata.lead_id])

    useEffect(() => {
        if(leadsAlldata.tag_ids){
            const tag=transformTags(leadsAlldata.tag_ids);
            setAlreadyTagged(tag);
        }

    }, [leadsAlldata.tag_ids]);
	useEffect(
		() => {
			try {
				amplitude.track(
					"Modal Viewed",
					{
						Agent_code: agentInfo.agentCode,
						duration: null, // Figure out what "calculated" means
						modal_name: "Lead Card Modal",
						trigger_source: null, // unique identifier that opened the modal
					}
				);
			} catch (err) {
				console.error(
					"LeadCard: Exception occurred during Amplitude communication attempt: %s",
					err,
					err,
				);
			}
		},
		[],
	);

    const closeData = () => {
        setFlowData(false);
    }
    const makeDial = async (toNumber, callee, fromNum) => {
        try {

            // Use the provided `fromNum` or default to `leadsAlldata.call_from`
            if (!fromNum) {
                fromNum = leadsAlldata.call_from;
            }
             dispatch(setStartSession(true));
             dispatch(setRingState('connecting'));
            // Attempt to connect the call
            const call = await device.connect({
                params: {
                    To: `+1${toNumber}`,
                    callerId: fromNum,
                    user: agentId,
                    tone: "default",
                    leadId: leadsAlldata.lead_id
                }
            });
            // Handle the call if the connection is successful
            const callTime = getTimestampForTimezone(agentInfo.timezone);
            dispatch(updateSpecificLead({ id: leadsAlldata.lead_id, field: 'last_contacted', value: callTime }))
            dispatch(setCall(call));
            dispatch(setRingState('connected')); //  Update to connected
            handleSoftPhone(call.status());
            setCallerId({ name: callee, lead_id: leadsAlldata.lead_id, outbound_number: fromNum, last_contact: leadsAlldata.last_contacted });
        } catch (error) {
            // Log the error for debugging purposes
            console.error("Error making the call:", error);

            // Handle different types of errors accordingly
            if (error.message.includes('Twilio')) {
                console.error("Twilio-related error:", error.message);
                // Handle Twilio-specific errors
                alert("Failed to connect the call. Please check the phone number and try again.");
            } else if (error.message.includes('Network')) {
                console.error("Network-related error:", error.message);
                // Handle network-related errors
                alert("Network issue. Please check your internet connection and try again.");
            } else {
                console.error("Unexpected error:", error.message);
                // Handle other unexpected errors
                alert("An unexpected error occurred. Please try again later.");
            }
            dispatch(setStartSession(false));
            dispatch(setRingState('disconnected'));
            // Optionally, you could retry the call or take other actions depending on the error
        }
    }
    const newEventPackage = [{ setNewEvent: setNewEvent, setTime: setTime, setDate: setDate }]
    const [timestamp, setTimestamp] = useState(null);
    const handleLeadData = (field, value) => {
        if(leadsAlldata[field] == value || !!!value){
            return
        }

        // console.log(field)
        // console.log(value)
        dispatch(updateSpecificLead({id:leadsAlldata.lead_id, field, value}))
        dispatch(updateSingleField({id: leadsAlldata.lead_id, field, value}))
    }
    const handleScriptType = (type) => {
        setScriptType(type);
		if (type === "dynamic") {
			try {
				amplitude.track(
					"Click Dynamic Script",
					{
						"Link Text": "Dynamic Script",
						trigger_source: "Script Modal",
						Agent_code: agentInfo.agentCode,
					}
				);
			} catch (err) {
				console.error(
					"handleScriptType: Exception occurred during Amplitude communication attempt: %s",
					err,
					err,
				);
			}
			try {
				amplitude.track(
					"Modal Viewed",
					{
						modal_name: "Dynamic Script Modal",
						trigger_source: "Script Modal",
						duration: null, // Figure out what "calculated" means
						Agent_code: agentInfo.agentCode,
					}
				);
			} catch (err) {
				console.error(
					"handleScriptType: Exception occurred during Amplitude communication attempt: %s",
					err,
					err,
				);
			}
		}
    }
    const handleProfileUpdate = (key, value) => {
        setProfile(prevState => ({
            ...prevState,
            [key]: value
        }));
    }
    const handleSelectTab = (option) => {
        if (option === leadCardTabOptions.QUOTE) {
            setScripting(true);
            selectTab(leadCardTabOptions.QUOTE)
            handleScriptType('qual')
			try {
				amplitude.track(
					"Click Quote",
					{
						"Link Text": "Quote",
						trigger_source: "Script Modal",
						Agent_code: agentInfo.agentCode,
					}
				);
			} catch (err) {
				console.error(
					"handleSelectTab: Exception occurred during Amplitude communication attempt: %s",
					err,
					err,
				);
			}
        } else if (option === leadCardTabOptions.SCRIPT) {
            setScripting(true);
            selectTab(leadCardTabOptions.QUOTE);
            handleScriptType('script');
			try {
				amplitude.track(
					"Modal Viewed",
					{
						modal_name: "Script Modal | REAL / BEST",
						trigger_source: "Script",
						duration: null,
						Agent_code: agentInfo.agentCode,
					}
				);
			} catch (err) {
				console.error(
					"handleSelectTab: Exception occurred during Amplitude communication attempt: %s",
					err,
					err,
				);
			}
			try {
				amplitude.track(
					"Click Script for Lead",
					{
						"Link Text": "Script",
						trigger_source: "Lead Card Script Tab",
						Agent_code: agentInfo.agentCode,
					}
				);
			} catch (err) {
				console.error(
					"handleSelectTab: Exception occurred during Amplitude communication attempt: %s",
					err,
					err,
				);
			}
			try {
				amplitude.track(
					"Click Script",
					{
						"Link Text": "Script",
						trigger_source: "Script Modal",
						Agent_code: agentInfo.agentCode,
					}
				);
			} catch (err) {
				console.error(
					"handleSelectTab: Exception occurred during Amplitude communication attempt: %s",
					err,
					err,
				);
			}
        }
        else {
            selectTab(option)
        }
    }
    const returnToLead = () => {
        setScripting(false);
        setQualifier(false);
        selectTab(leadCardTabOptions.TEXT)
    }
    const handleSetQualifier = () => {
        setQualifier(false)
    }
    const isStateEmpty = (state) => {
        return !Object.values(state).some(value => value !== null);
    };

    const debouncedVMReqeust = useDebouncedCallback(async (ts)=>{
        // console.log('req-start ts:', ts, {profile})
        await runVM(profile, leadsAlldata.lead_id, dispatch, agentInfo.agentId);
        // console.log('req-end ts:', Date.now())
    })

    const setVMRequest = async () => {
        // console.log('setVMRequest', {prevProfile, profile})

        // cancel the pending request
        // to avoid duplicate calls
        if(debouncedVMReqeust.isPending() === true){
            // console.log('setVMRequest - pending request canceled')
            debouncedVMReqeust.cancel()
        }

        debouncedVMReqeust(Date.now())
        setPrevProfile(profile)
    }

    useEffect(() => {


        // don't trigger request if not in the quote tab
        if(selected !== leadCardTabOptions.QUOTE){
            return
        }

        // don't trigger the request if nothing has actually changed
        if(isDeepEqual(prevProfile, profile)){
            return
        }

        if(leadsAlldata && !isStateEmpty(profile) && ((profile.tobacco==='yes' && tobaccoRatings.includes(profile.healthRating)) || (profile.tobacco==='no' && nonTobaccoRatings.includes(profile.healthRating)))){
            setVMRequest()
        } else if(leadsAlldata && profile.productOption !== '7'){
            setVMRequest()
        }

        setPrevProfile(profile)
    }, [profile,selected]);

    useEffect(() => {
        setApptSet(false);
    }, [leadsAlldata && leadsAlldata.lead_id]);
    const handleSetScripting = () => {
        setScripting(true);
        selectTab(leadCardTabOptions.QUOTE)
        handleScriptType('qual')
    }
    const expiration = (parseInt(leadsAlldata.exclusivity) - parseInt(timestamp));

    const [canMessageTCPA, setCanMessageTCPA] = useState(false)
    const currentAgentTextingNumber = useSelector((state) => state.conversations.currentAgentTextingNumber)
    const currentLeadTextingNumber = useSelector((state) => state.conversations.currentLeadTextingNumber)

    useEffect(() => {
        if (isFeature875Enabled) {
            setCanMessageTCPA(canMessageCurrentLeadTCPA(leadsAlldata, conversations, currentAgentTextingNumber, currentLeadTextingNumber))
        }
    }, [conversations, currentAgentTextingNumber, currentLeadTextingNumber])
	const refreshLeadData = async () => {
		// Setting a timeout to avoid a race condition with the back end.
		// This gives it time to make the necessary updates to the tags
		// tables.
		setTimeout(
			async () => {
				if (leadsAlldata.lead_id) {
					await dispatch(
						fetchLeadDataThunk(
							{
								leadId: leadsAlldata.lead_id,
							},
						)
					);
				}
			},
			1200
		);
	}
    const queueConvoProps = {
        handleLeadData,
        expiration,
        setLoading,
        refreshLeadData,
        textingNumbers,
        setConversations,
        conversations,
        agentId,
        canMessageTCPA,
        setCanMessageTCPA,
        selectedNumber,
        teamId: agentInfo.teamId,
    }

    const dispositionBlockProps = {
        handleLeadData,
        removeTag,
        addTag,
        from: "dash",
        updateStatusName,
        canMessageTCPA,
        leadId: leadsAlldata.lead_id,
        tags: leadsAlldata.tag_ids,
        type: leadsAlldata.parent_status,
    }

    const dynamicScriptProps = {
        handleSelectedTab,
        quoteTab: selectedTab,
        handleProfileUpdate,
        setFaceAmount,
        possibleConditions,
        setPossibleConditions,
        selectedProducts,
        setSelectedProducts,
        setResults,
        profile,
        setProfile,
        handleLeadData,
    }

    const scriptingProps = {
        handleLeadData,
        setProfile,
        possibleConditions,
        setPossibleConditions,
        profile,
        setApptSet,
        newEventPackage,
        setEvent,
        newAppt
    }

    const qualifierProps = {
        from: 'script',
        possibleConditions,
        setPossibleConditions,
        setProfile,
        profile,
        setResults,
        handleLeadData,
        handleSetQualifier,
        agentId,
    }

    // refactor to use leadsAlldata
    const leadDataNonConditionalProps = {
        from,
        setApptSet,
        handleSetScripting,
        handleScriptType,
        setScripting,
        permission,
        selectTab,
        setQualifier,
        selectedProducts,
        setSelectedProducts,
        possibleConditions,
        setPossibleConditions,
        profile,
        setProfile,
        setResults,
        setFlowData,
        handleLeadData,
        newEventPackage,
        setEvent,
        setNewAppt,
        newAppt,
        expiration,
        alreadyTagged,
        qualifier,
        handleQualifier,
        openViaDial,
        maxList
    }

    const dialProps = {
        apptSet,
        theCall,
        jumpIntoQueue,
        handleLeadData,
        fetchQueue,
        from: "session",
        canMessageTCPA,
        makeDial: dialPackage !== undefined ? dialPackage[0].makeDial : null,
        setDialGroupDone: dialPackage !== undefined ? dialPackage[0].setDialGroupDone : null,
        incrementQueue: dialPackage !== undefined ? dialPackage[0].incrementQueue : null,
        currentLead: dialPackage !== undefined ? dialPackage[0].currentLead : null,
        dialAmount: dialPackage !== undefined ? dialPackage[0].dialAmount : null,
        device: dialPackage !== undefined ? dialPackage[0].device : null,
    }

    // refactor to use leadsAlldata
    const reccomendationProps = {
        handleSelectedTab,
        selectedTab,
        selectedProducts,
        setSelectedProducts,
        handleProfileUpdate,
        setFaceAmount,
        faceAmount,
        term,
        setTerm,
        possibleConditions,
        results,
        profile,
        healthRating,
        setHealthRating,
    }

    // =========== apointemnt popup api =========
    const [calendar, setCalendar] = useState(false);

    const setAppointment = async (event, video) => {
        try {
            const requestOptions = {
                method: 'POST',
                body: JSON.stringify({
                    agent: agentId,
                    team: agentInfo.teamId,
                    leadId: leadsAlldata.lead_id,
                    event: event,
                    video: video
                }),
            };
            const response = await fetchWithDefaults('/google/create/event', requestOptions);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const jsonData = await response.json();
            // Refresh the scheduled calls and appointments data to show the new appointment immediately
            dispatch(fetchActivityThunk({ agentIdNumber: agentId }));
            setNewAppt(jsonData.event)
            setNewEvent(false);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    return (
        <>
            {/*<LeadCardTopBar expiration={expiration} setLoading={setLoading} textingNumbers={textingNumbers} qualifier={qualifier} handleQualifier={handleQualifier} calendarChange={calendarChange} setCalendarUsing={setCalendarUsing} setEvent={setEvent} newEventPackage={newEventPackage} newAppt={newAppt} setNewAppt={setNewAppt} setNewEvent={setNewEvent} data={data}/>*/}
            {leadsAlldata && (
                <>
                    <SuccessAlert message={'Status Changed'} setSuccessTrigger={setSuccessTrigger} successTrigger={successTrigger} />
                    {leadsAlldata.parent_status === 'client' ? (
                        <div className="leadCardDataWrapper">
                            <div className="centerQueue">
                                {scripting && (
                                    <>
                                        <div className="recLink solidQuilityActiveButton" style={{ position: 'absolute', top: '10px' }} onClick={() => returnToLead()}>Return</div>
                                        <div className="productTabs" style={{ marginTop: '45px' }}>
                                            <div className={`productTab ${scriptType === 'script' && 'selectedTab'}`} onClick={() => handleScriptType('script')}>Scripts</div>
                                            <div className={`productTab ${scriptType === 'dynamic' && 'selectedTab'}`} onClick={() => handleScriptType('dynamic')}>Dynamic Script <span style={{ fontSize: '12px', position: 'absolute' }}>  Beta</span></div>
                                            <div className={`productTab ${scriptType === 'qual' && 'selectedTab'}`} onClick={() => handleScriptType('qual')}>Qualifier Q's</div>
                                        </div>
                                    </>
                                )}
                                {scripting && !qualifier ? (
                                    scriptType === 'dynamic' ? (
                                        <Scripting {...dynamicScriptProps} />
                                    ) : scriptType === 'script' ? (
                                        <Script {...scriptingProps} />
                                    ) : (
                                        <span className="qualifierAdjustment">
                                            <Qualifier {...qualifierProps} />
                                        </span>
                                    )
                                ) : (
                                    <LeadData {...leadDataNonConditionalProps} makeDial={from === 'session' ? dialPackage[0].makeDial : makeDial} />
                                )}
                                <div className="dispositionWrapper">
                                    {from === 'session' ? (
                                        <Dial {...dialProps} />
                                    ) : (
                                        <DispositionBlock {...dispositionBlockProps} />
                                    )}
                                </div>
                            </div>
                            <div className="rightQueue">
                                <RightQueueHeader recording={leadsAlldata.recording_count} selected={selected} handleSelectTab={handleSelectTab} setQualifier={setQualifier} />
                                {selected == leadCardTabOptions.SCRIPT ? (
                                    <QueueScripts handleNewObjection={handleNewObjection} currentLead={leadsAlldata} scriptId={currentScript} />
                                ) : selected == leadCardTabOptions.TEXT ? (
                                    //ActualConversation({setLoading,lead,conversation,travelPathway,handleSendText,convoId,handleInputChange,inputValue})
                                    <QueueConvo {...queueConvoProps} />
                                ) : selected == leadCardTabOptions.EMAIL ? (
                                    expiration > 0 || isNaN(expiration) ? (
                                        <Email email={leadsAlldata.email} setIsEmailOpen={setIsEmailOpen} />
                                    ) : (
                                        <div className="noResults">You can no longer Email this lead</div>
                                    )
                                ) : selected == leadCardTabOptions.NOTES ? (
                                    <QueueNotes handleLeadData={handleLeadData} notes={leadsAlldata.notes} leadId={leadsAlldata.lead_id} agentId={agentId} plan={leadsAlldata.policy_plan} />
                                ) : selected == leadCardTabOptions.RECORDING ? (
                                    <LeadCallRecordings lead={leadsAlldata.lead_id} />
                                ) : (
                                    <Recommendation {...reccomendationProps} />
                                )}
                            </div>
                        </div>
                    ) : (
                        <div className="leadCardDataWrapper">
                            <div className="centerQueue">
                                {scripting && (
                                    <>
                                        <div className="recLink solidQuilityActiveButton" style={{ position: 'absolute', top: '10px' }} onClick={() => returnToLead()}>Return</div>
                                        <div className="productTabs" style={{ marginTop: '45px' }}>
                                            <div className={`productTab ${scriptType === 'script' && 'selectedTab'}`} onClick={() => handleScriptType('script')}>Scripts</div>
                                            <div className={`productTab ${scriptType === 'dynamic' && 'selectedTab'}`} onClick={() => handleScriptType('dynamic')}>Dynamic Script</div>
                                            <div className={`productTab ${scriptType === 'qual' && 'selectedTab'}`} onClick={() => handleScriptType('qual')}>Qualifier Q's</div>
                                        </div>
                                    </>
                                )}
                                {scripting && !qualifier ? (
                                    scriptType === 'dynamic' ? (
                                        <Scripting {...dynamicScriptProps} />
                                    ) : scriptType === 'script' ? (
                                        <Script {...scriptingProps} />
                                    ) : (
                                        <span className="qualifierAdjustment">
                                            <Qualifier {...qualifierProps} />
                                        </span>
                                    )
                                ) : (
                                    <LeadData {...leadDataNonConditionalProps} makeDial={from === 'session' ? dialPackage[0].makeDial : makeDial} />
                                )}
                                <div className="dispositionWrapper">
                                    {from === 'session' ? (
                                        <Dial {...dialProps} />
                                    ) : (
                                        <div className="dispositionHolder">
                                            <DispositionBlock {...dispositionBlockProps} />
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="rightQueue">
                                <RightQueueHeader recording={leadsAlldata.recording_count} selected={selected} handleSelectTab={handleSelectTab} setQualifier={setQualifier} />
                                {selected == leadCardTabOptions.SCRIPT ? (
                                    <QueueScripts handleNewObjection={handleNewObjection} currentLead={leadsAlldata} scriptId={currentScript} />
                                ) : selected == leadCardTabOptions.TEXT ? (
                                    //ActualConversation({setLoading,lead,conversation,travelPathway,handleSendText,convoId,handleInputChange,inputValue})
                                    <QueueConvo {...queueConvoProps} />
                                ) : selected == leadCardTabOptions.EMAIL ? (
                                    expiration > 0 || isNaN(expiration) ? (
                                        <Email email={leadsAlldata.email} setIsEmailOpen={setIsEmailOpen} />
                                    ) : (
                                        <div className="noResults">You can no longer Email this lead</div>
                                    )
                                ) : selected == leadCardTabOptions.NOTES ? (
                                    <QueueNotes handleLeadData={handleLeadData} notes={leadsAlldata.notes} leadId={leadsAlldata.lead_id} agentId={agentId} plan={leadsAlldata.policy_plan} />
                                ) : selected == leadCardTabOptions.RECORDING ? (
                                    <LeadCallRecordings lead={leadsAlldata.lead_id} />
                                ) : (
                                    <Recommendation {...reccomendationProps} />
                                )}
                            </div>
                        </div>
                    )}

                    {newEvent && (
                        null
                    )}
                    {loadingGif && (
                        <div className="loadingScreen">
                            <div className="loaderWrapper">
                                <img src={image} alt="Loading Gif" style={{ width: '100%' }} />
                            </div>
                        </div>
                    )}
                </>
            )}
            {flowData && (
                <div className="flowDataWrapper">
                    <div className="flowDataContent">
                        <div className="closeWindow" onClick={() => closeData()}>X</div>
                        {flowData.map((item, index) => (
                            <>
                                <div className="title">Workflow Info</div>
                                <div className="flowDataInfoWrapper">
                                    <div className="flowDataInfoTitle">
                                        Workflow Name:
                                    </div>
                                    <div className="flowDataInfoInfo">
                                        {item.name}
                                    </div>
                                </div>
                                <div className="flowDataInfoWrapper">
                                    <div className="flowDataInfoTitle">
                                        Date Started:
                                    </div>
                                    <div className="flowDataInfoInfo">
                                        {UnixTimestampToDate(item.start)}
                                    </div>
                                </div>
                                <div className="flowDataInfoWrapper">
                                    <div className="flowDataInfoTitle">
                                        Workflow Length:
                                    </div>
                                    <div className="flowDataInfoInfo">
                                        {item.totalResult} Actions
                                    </div>
                                </div>
                                <div className="flowDataInfoWrapper">
                                    <div className="flowDataInfoTitle">
                                        Actions Remaining:
                                    </div>
                                    <div className="flowDataInfoInfo">
                                        {item.activeCount}
                                    </div>
                                </div>
                                <div className="buttonWrapper">
                                    <div className="accentButton" style={{ margin: 'auto', marginTop: '25px' }} onClick={() => stopFlow(item.theId)}>Stop Workflow</div>
                                </div>
                            </>
                        ))}
                    </div>
                </div>
            )}

            {newEvent && (
                <AddEvent from={from} setAppointment={setAppointment} calendar={calendar} setNewEvent={setNewEvent} agentTimezone={agentInfo.timezone} date={date} time={time} />
            )}
             {event && (
            <EditEvent
              from={from}
              setUpdate={setUpdate}
              setEvent={setEvent}
              calendar={calendar}
              event={event}
            />
          )}

        </>
    );
}

export default LeadCard;

//